/// <reference path="./FormItem.ts" />
namespace HA.Core.HTML.Form {
    //noinspection TsLint
    export class Button extends FormItem {

        /**
         *
         * @returns {string}
         */
        public getType() {
            return "Button";
        }

        protected createSelf() {
            let btn: Tag = null;
            if (this.hasNot("ft")) {
                btn = new Div();
                const v = this.get("v");
                btn.addClass("buttonbox");
                btn.setText(v);
            } else {
                const icon = this.get("i");
                let formClass = ["formi"];
                let iconBox = undefined;
                if (icon) {
                    iconBox = {
                        t: "span",
                        class: icon
                    };
                }
                if (this.has("class")) {
                    formClass.push(this.get("class"));
                }
                btn = new Tag({
                    attributes: [
                        {n: "formi", v: 1},
                    ],
                    c: [
                        {t: "div", class: "state"},
                        {
                            c: [
                                {
                                    c: [
                                        {
                                            attributes: [
                                                {n: "ft", v: this.get("ft")},
                                                {n: "formid", v: this.get("formid")},
                                            ],
                                            c : [iconBox, this.get("label")],
                                            classes: ["buttonbox", "fc"],
                                            t: "div",
                                        }],
                                    class: "b-box",
                                    t: "div",
                                }],
                            class: "ibox",
                            t: "div",
                        },
                    ],
                    classes: formClass,
                    t: "div",
                });
            }
            this.setElement(btn.getElement());


        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            if (typeof data === "string") {
                data = toMap({v: data});
            }
            super.initialize(data);
        }
    }
}
